export default function Logo({ size = "default" }) {
    const heights = {
        small: "h-7",
        default: "h-10",
        large: "h-14",
    };
    return (
        <img
            src="/brand/carvaelis-logo.png"
            alt="Carvaelis"
            className={`${heights[size]} w-auto select-none block`}
            draggable="false"
        />
    );
}
